import React, { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { LogoMark } from "../components/Logo";
import { Loader2, CheckCircle2, AlertTriangle, Trash2 } from "lucide-react";

export default function WithdrawRequest() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("idle"); // idle | loading | done | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setState("error");
      setMessage("Token mancante nell'URL.");
    }
  }, [token]);

  const submit = async () => {
    if (!token) return;
    setState("loading");
    try {
      await api.post("/auth/withdraw-request", { token });
      setState("done");
      setMessage("Richiesta cancellata. I tuoi dati sono stati eliminati dai nostri sistemi.");
    } catch (e) {
      setState("error");
      setMessage(e?.response?.data?.detail || "Errore");
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0E27] flex items-center justify-center p-6">
      <div className="bg-white border border-black rounded-3xl p-10 max-w-lg w-full text-center" data-testid="withdraw-page">
        <div className="flex justify-center mb-4"><LogoMark className="w-12 h-12"/></div>
        {state === "done" ? (
          <>
            <CheckCircle2 className="w-14 h-14 text-green-600 mx-auto mb-4"/>
            <h1 className="font-display text-3xl mb-2">Richiesta cancellata</h1>
            <p className="text-[#555] mb-6">{message}</p>
            <Link to="/"><Button className="rounded-full bg-[#3B82F6] hover:bg-black h-11">Vai alla home</Button></Link>
          </>
        ) : state === "error" ? (
          <>
            <AlertTriangle className="w-14 h-14 text-red-600 mx-auto mb-4"/>
            <h1 className="font-display text-3xl mb-2">Errore</h1>
            <p className="text-[#555] mb-6">{message}</p>
            <Link to="/"><Button variant="outline" className="rounded-full h-11">Torna alla home</Button></Link>
          </>
        ) : (
          <>
            <Trash2 className="w-14 h-14 text-[#3B82F6] mx-auto mb-4"/>
            <h1 className="font-display text-3xl mb-2">Ritira richiesta di iscrizione</h1>
            <p className="text-[#555] mb-6">
              Stai per cancellare la richiesta di registrazione e tutti i dati personali associati.
              <br/><br/>L'operazione è irreversibile (art. 17 GDPR · diritto all'oblio).
            </p>
            <Button onClick={submit} disabled={state === "loading"} data-testid="withdraw-confirm" className="rounded-full bg-red-600 hover:bg-red-700 text-white h-11">
              {state === "loading" ? <><Loader2 className="w-4 h-4 mr-2 animate-spin"/>Cancellazione…</> : "Conferma cancellazione"}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
